import React from "react";
import "./programsTemplate.scss";
import PresentationSheet from "../../molecules/presentationSheet/presentationSheet";
import ProgramCard from "../../molecules/programCard/programCard";
import palette from "styles/palette.scss";
import imgSrc from "../../../bgImages/home.JPG";
import PresentationSheetContent from "../../molecules/presentationSheetContent/presentationSheetContent";
import PresentationSheetContent2 from "../../molecules/presentationSheetContent2/presentationSheetContent2";
import PageTitle from "componets/molecules/PageTitle/pageTitle";
import PersonalFooter from "componets/organisms/personalFooter/personalFooter";

const ProgramsTemplate = ({ contentData }) => {
  const breadcrumsData = [
    { text: "Inicio", link: "/" },
    { text: "Programas", link: "/programas" },
  ];
  return (
    <div className="programs-template__main-container">
      <div>
        {!contentData ? (
          <p>Un momento, mientras la información se carga</p>
        ) : (
          <>
            <PageTitle
              breadData={breadcrumsData}
              type="left"
              imgSrc={imgSrc}
              data={{
                title: contentData[0].title,
                description: contentData[0].description,
              }}
            />

            <div className="programs-template__upper">
              <PresentationSheet
                image={contentData[1].imgURL}
                altImg={contentData[1].alt}
                color={palette.ligthGray}
                children={
                  <PresentationSheetContent
                    title1={contentData[1].title1}
                    content1={contentData[1].description1}
                    title2={contentData[1].title2}
                    subtitle2={contentData[1].subtitle2}
                    content2={contentData[1].description2}
                  />
                }
              />
            </div>
            <div className="programs-template__pregrado">
              <h1 className="programs-template__title-section-pregrado">
                PROGRAMAS ACADÉMICOS PREGRADO
              </h1>
              {contentData[4].map((pregradoCard, index) => (
                <React.Fragment key={index}>
                  {pregradoCard.type == "Pregrado" && (
                    <div className="programs-template__pregrado-cards">
                      <ProgramCard
                        programId={pregradoCard.id}
                        image={pregradoCard.imgURL}
                        title={pregradoCard.title}
                        label={undefined}
                        link={"/programas/programa"}
                        paragraph={pregradoCard.code}
                      />{" "}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <div className="programs-template__posgrado">
              <h1 className="programs-template__title-section-posgrado">
                PROGRAMAS ACADÉMICOS POSGRADOS
              </h1>
              {contentData[4].map((posgradoCard, index) => (
                <React.Fragment key={index}>
                  {posgradoCard.type == "Posgrado" && (
                    <div className="programs-template__pregrado-cards">
                      <ProgramCard
                        programId={posgradoCard.id}
                        image={posgradoCard.imgURL}
                        title={posgradoCard.title}
                        label={true}
                        link={"/programas/programa"}
                        paragraph={posgradoCard.code}
                      />{" "}
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
            <div className="programs-template__lower">
              <div className="programs-template__lower-card">
                <PresentationSheet
                  image={contentData[2].imgURL}
                  color={"#B86800"}
                  children={
                    <PresentationSheetContent2
                      title={contentData[2].title}
                      content={contentData[2].description}
                      link={contentData[2].url}
                      linkText={contentData[2].urlText}
                    />
                  }
                />
              </div>
              <div className="programs-template__lower-card">
                <PresentationSheet
                  image={contentData[3].imgURL}
                  color={"#7D2D00"}
                  children={
                    <PresentationSheetContent2
                      title={contentData[3].title}
                      content={contentData[3].description}
                      link={contentData[3].url}
                      linkText={contentData[3].urlText}
                    />
                  }
                />
              </div>
            </div>

            <PersonalFooter textSize={1} />
          </>
        )}
      </div>
    </div>
  );
};

export default ProgramsTemplate;
